
import React from 'react'
import styled from 'styled-components'
import gamedevelopmentImage from '../assets/image 118.png'
import pingimg from '../assets/pngwing 1.png'

const MainWrapContanier = styled.div``
const MobileAppImage = styled.img`
/* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
  @media (max-width:600px){
  width:100%;
  height:auto;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:auto;
}
`
const ContanierHead1 = styled.h1`
color:darkblue;
font-size: 48px;
margin-top: 20px;
margin-bottom: 20px;
text-align: center;
line-height: 1.5;
@media (max-width: 600px) {
    font-size: 16px;
    
  }
  @media (min-width:601px) and (max-width:1024px){
    font-size: 26px;
}
`
const ContanierPara7 = styled.p`
text-align: center;
justify-content: center;
margin-left: 175px;
margin-right: 175px;
font-size: 23px;
/* padding:80px; */
margin-top:50px;
margin-bottom: 50px;
line-height:2;
@media (max-width: 600px) {
    

    
        font-size: 0.875rem; /* Font size for smaller screens (14px) */
        margin:20px;
    
}
@media (min-width:601px) and (max-width:1024px){
    font-size: 16px;
    margin:20px;
}
@media (min-width:1025px) and (max-width:1400px){
    
    margin:20px;
}
`
const MobileHeadPara = styled.div``
const FrontHead = styled.h1`
  position: absolute;
  top: 300px;
  color: white;
  text-align: center;
  
  left: 100px;
  z-index: 100;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7); /* Adding shadow effect */
  
  @media (max-width: 600px) {
    font-size: 18px;
    top: 170px;
  }

  @media (min-width: 601px) and (max-width: 1024px) {
    font-size: 25px;
    top: 250px;
  }
  @media (min-width:1025px) and (max-width:1440px){
    font-size: 45px;
    top: 350px;
    left: 200px;
}
  @media (min-width: 1441px) and (max-width: 2100px) {
    top: 350px;
    left: 400px;
    font-size: 50px;
  }
`;

const MobileAppImage2 = styled.img`
position: absolute;
top: 200px;
left:100px;
z-index: 100;
@media (max-width:600px) {
  top:120px;
  left: 65px;
  width: 130px;
  height: 40px;
}
@media (min-width:601px) and (max-width:1024px){
  top:190px;
  left: 65px;
  width: 150px;
  height: 42px;
}
@media (min-width:1025px) and (max-width:1440px){
  top:250px;
  left: 185px;
  
}
@media (min-width:1441px) and (max-width:2100px){
  
  top: 250px;
left:400px;
}

`

const ArVr = () => {
  return (
    <>

        <MainWrapContanier>

          <MobileAppImage src={gamedevelopmentImage} alt = 'Background'/>
          <MobileAppImage2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500" src={pingimg} alt = 'Background'/>
          <FrontHead data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">AR/VR<br></br>DESIGN</FrontHead>
          <MobileHeadPara>

          <ContanierHead1 data-aos="fade-right">Design that delights, user experience that endures </ContanierHead1>
          <ContanierPara7 data-aos="fade-right">
          Delight in the rich and excellent user experience and fast adaption of app
           design for your customer. We unite the mobile app design and development
           resources towards creating seamless App experience.
           <br></br><br></br>
           From gathering end user data and research to developing prototypes and 
           performing usability assessments. We assist companies to create immersive
           and engaging products that can target maximum users and produce the 
           desired results through high customer satisfaction. We know what a customer
           needs at what time, so we are here to help you in gaining customer attention.
           We design sophisticated and intuitive interfaces that are visually tempting and
           easy to use.
           <br></br><br></br>
           Get the fascinate user involvement by using the latest psychology driven
           design models and frameworks. Through our designs, seamless usability and
           interactivity we will help you getting user experience that generate maximum
            conversion rates to increase your project investment return       
          </ContanierPara7>

          </MobileHeadPara>


        </MainWrapContanier>
  
    </>
  )
}

export default ArVr
 

// import React, { useState,useEffect } from 'react'

// const ArVr = () => {
   
 
//   const  [count, setCount ] = useState(0);
//   const  [count1, setCount1 ] = useState("Sultan Azhar");

// useEffect ( () =>{
//   console.log("This is useEffect Hook");

// },[count1])

 


//   function UpdataData (){
//     setCount(count+1)
//   }
//   function UpdataData1 (){
//     setCount1("Azharuddin")
//   }
  
//   return (
//     <div>
//       <h1>{count1}</h1>
//       <h1>{count}</h1>
//       <button onClick= {UpdataData}> Click me </button>
//       <button onClick= {UpdataData1}> Update Data </button>
//     </div>
//   )
// }

// export default ArVr

